module.exports = __webpack_public_path__ + "img/traffic.dae5f981.svg";